import React from "react";
import { classNames } from "repoV2/utils/common/render/classNames";
import ExlyImage from "repoV2/features/Common/modules/ExlyImage/ExlyImage";
import { checkout_page_listing_cover_img_width } from "repoV2/features/CheckoutPages/constants/CheckoutPages.constants";
import { useCheckoutBasicDetailsContext } from "../CheckoutBasicDetailsContextProvider";
import styles from "./TitleSection.module.scss";
import useMerchandiseImages from "../PaymentDetailsSection/modules/FormGroups/modules/MerchandiseDetailsFormGroup/utils/useMerchandiseImages";

export const TitleSection = () => {
    const {
        title,
        coverImage,
        subtitleText,
        subtitleIcon,
        creatorSubtitle,
        defaultListingTitle,
    } = useCheckoutBasicDetailsContext();

    const { variantImages } = useMerchandiseImages();

    const subTitleRenderText = subtitleText ? (
        <>
            <>By</>
            <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: subtitleText,
                }}
            />
        </>
    ) : (
        <></>
    );

    return (
        <section className={styles.container}>
            <div>
                <div
                    className={styles.title}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: title || defaultListingTitle,
                    }}
                />
                <div
                    className={classNames(
                        styles.subTitle,
                        !coverImage && styles.subTitleStyles
                    )}
                >
                    <ExlyImage
                        src={subtitleIcon}
                        fetchWidth={80}
                        width={80}
                        alt="creator icon"
                        className={styles.coverIcon}
                    />
                    {/* Incase creator subtitle is there (only for dynamic payment links), we show creatorSubtitle else we show subtitleText
                        creatorSubTitle is the text that the creator has set for thier Custom Checkout Page
                        subtitleText is the creator name that be show on default checkout pages
                    */}
                    {creatorSubtitle ? (
                        <div
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{
                                __html: creatorSubtitle,
                            }}
                        />
                    ) : (
                        subTitleRenderText
                    )}
                </div>
                <div className={styles.stripClass} />
            </div>
            {coverImage && (
                <ExlyImage
                    fetchWidth={checkout_page_listing_cover_img_width}
                    // in checkout pages, with page speed being priority we do not show
                    // any carousal like thing, and only show the first image of the variant
                    src={variantImages[0] || coverImage}
                    alt={defaultListingTitle}
                    className={classNames(styles.coverImage)}
                    loading="eager"
                />
            )}
        </section>
    );
};
